import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import EmailPopup from 'apps/auth/components/history/send/popup/EmailPopup';
import RenamePopup from 'apps/auth/components/history/send/popup/RenamePopup';
import { GET_HELP_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { TO_BANK, TRANSFER_OUT } from 'apps/auth/constants/GaConstants';
import { GA_RENAME_PAYMENT_URL, HELP_MOBILE } from 'apps/auth/constants/UrlConstants';
import { getLangCountryPrefix, resolveArguments } from 'apps/auth/helpers/utils';
import { useThemeDetector } from 'apps/auth/hooks/theme';

const ActivityMorePopup = ({ popupRef = null, ...props }) => {
    const item = props.item;
    const { theme } = useThemeDetector();

    const getMenuItemsForOutComingransfer = () => {
        return (
            <>
                <PopupButton
                    iconName="pencil"
                    text={props.chequeRenameOperation}
                    onClick={(e) => {
                        e.preventDefault();
                        popupRef?.current?.close();
                        popupRef?.current?.open(<RenamePopup isGlobalAccount={true} item={item} urlAction={GA_RENAME_PAYMENT_URL} popupRef={popupRef} />);
                    }}
                />
                {item.mobileInfo.gtPayId && (
                    <PopupButton
                        iconName="document"
                        text={props.chequeEmailDetailsButton}
                        onClick={(e) => {
                            e.preventDefault();
                            popupRef?.current?.close();
                            popupRef?.current?.open(<EmailPopup isGlobalAccount={true} payId={item.mobileInfo.gtPayId} popupRef={popupRef} />);
                        }}
                    />
                )}
            </>
        );
    };

    const getMenuItemsForOther = () => {
        return <></>;
    };

    const getMenuItems = () => {
        if (item.mobileInfo.icon === TO_BANK || item.mobileInfo.icon === TRANSFER_OUT) return getMenuItemsForOutComingransfer();
        else {
            return getMenuItemsForOther();
        }
    };

    const getHeader = () => {
        return <p>{resolveArguments(props.morePopupTitle, item.id)}</p>;
    };

    return (
        <SimplePopup text={getHeader()} popupRef={popupRef}>
            {getMenuItems()}
            <PopupButton
                text={props.morePopupSupportTitle}
                iconName="lifebuoy"
                href={`${getLangCountryPrefix(props.lang, props.country)}${HELP_MOBILE}?mode=${theme}`}
                onClick={() => amplitude.getInstance().logEvent(GET_HELP_CLICKED)}
            />
        </SimplePopup>
    );
};

ActivityMorePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    item: PropTypes.object,
};

const mapStateToProps = (state) => ({
    morePopupTitle: state.messages.pageMessages.morePopupTitle,
    morePopupFaqTitle: state.messages.pageMessages.morePopupFaqTitle,
    morePopupSupportTitle: state.messages.pageMessages.morePopupSupportTitle,
    chequeRenameOperation: state.messages.pageMessages.chequeRenameOperation,
    chequeEmailDetailsButton: state.messages.pageMessages.chequeEmailDetailsButton,
    lang: state.language.lang,
    country: state.app.country,
});
export default connect(mapStateToProps, null)(ActivityMorePopup);
